import React from 'react'
import {
  TextField
} from '@material-ui/core';

const PharmacologicalRecommendationsPDF = ({pharmacologicalRecommendationsPDF, handleChange}) => {
  return (
    <TextField  label="Recomendaciones Farmacologicas Completas"
      variant="outlined"
      name={'pharmacological_recommendations_pdf'}
      multiline
      fullWidth
      margin={'normal'}
      value={pharmacologicalRecommendationsPDF || ''}
      onChange={({target}) => handleChange(target)}
      type="text" />
  )
}

export default PharmacologicalRecommendationsPDF
